// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

import { createContext, useContext } from 'react';

export type Locale = 'zh' | 'en';
export type TranslationParams = Record<string, string | number>;

export interface TranslateFn {
  (key: string): string;
  (key: string, fallback: string): string;
  (key: string, params: TranslationParams): string;
  (key: string, fallback: string, params: TranslationParams): string;
}

export type I18nContextValue = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: TranslateFn;
};

export const I18nContext = createContext<I18nContextValue | null>(null);

export function useI18nContext() {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    throw new Error('useI18n must be used within I18nProvider');
  }
  return ctx;
}
